import $ from 'jquery';
/* eslint-disable */
import slick from 'slick-carousel';
/* eslint-enable */
import settings from '../../../../scripts/settings';
/*
 * List of Dom Elements
 */
const elements = {
  $gallery: $('.js-gallery'),
  $galleryNav: $('.js-gallery-nav'),
  $status: $('.js-gallery-status'),
};

function init() {
  //* Status counter
  elements.$gallery.on('init reInit afterChange', (event, slickInstance, currentSlide) => {
    const i = (currentSlide === undefined ? 0 : currentSlide) + 1;
    elements.$status.text(`${i}/${slickInstance.slideCount}`);
  });

  //* Gallery
  elements.$gallery.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.js-gallery-nav',
    autoplay: false,
    infinite: true,
    prevArrow: $('.js-gallery-prev'),
    nextArrow: $('.js-gallery-next'),
  });

  //* Gallery Nav
  // Set preferred slidesToShow
  let slides = elements.$galleryNav.data('slide-count');

  if (slides === undefined) {
    slides = 8;
  }

  const childElements = $('.js-gallery-nav').children().length;
  // Check if we can fulfil the preferred slidesToShow
  if (slides > childElements) {
  // if slides less than 8 set slides to the child value so that gallery nav does not show
    slides = childElements;
    $('.js-gallery-nav').addClass('c-gallery-nav__no-scroller');
  }

  elements.$galleryNav.slick({
    slidesToShow: slides,
    slidesToScroll: 1,
    asNavFor: '.js-gallery',
    infinite: true,
    centerMode: true,
    prevArrow: settings.arrowPrev,
    nextArrow: settings.arrowNext,
    focusOnSelect: true,
  });

  //* Make thumbnail nav re-appear when hidden on smaller viewport widths via CSS display:none
  let resizeTimer;

  $(window).on('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      elements.$galleryNav.slick('refresh');
    }, 250);
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/arena/gallery/mando-ui.gallery.js